import { useLayoutEffect, useState } from 'react';


export const deviceSize = {
    mobileS: {
        num: 320,
        px: '320px'
    },
    mobileM: {
        num: 375,
        px: '375px'
    },
    mobileL: {
        num: 425,
        px: '425px'
    },
    tablet: {
        num: 768,
        px: '768px'
    },
    laptop: {
        num: 1024,
        px: '1024px'
    },
    laptopL: {
        num: 1140,
        px: '1140px'
    },
    desktop: {
        num: 2560,
        px: '2560px'
    }
};

function getWindowDimensions() {
    if (typeof window !== 'undefined') {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height
        };
    }
    return { width: 0, height: 0 };
}

export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useLayoutEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, []);

    return windowDimensions;
}